export default "__VITE_ASSET__Dcg0KlkD__"